export const ynetLink = 'https://www.ynet.co.il/';
